import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import EngineeringIcon from '@mui/icons-material/Engineering';
import Avatar from '@mui/material/Avatar';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { getstaff } from '../redux/staff';
import { Camera, CameraResultType } from '@capacitor/camera';
import Progress from '../components/Loader';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function BasicModal() {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [gender, setGender] = React.useState('none');
  const [position, setPosition] = React.useState('none');
  const [iniPosition, setIniPosition] = React.useState('none');
  const [employmentType, setEmploymentType] = React.useState('none');
  const [marrital, setMarrital] = React.useState('none');
  const [personName, setPersonName] = React.useState([]);
  const [person, setPerson] = React.useState('');
  const [base64, setBase64] = React.useState('');
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [canLogin, setCanLogin] = React.useState(false);
  const dispatch = useDispatch();

  const names = ['Mobile Phone', 'Vehicle', 'Motorbike', 'Computer'];

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleChange = (event) => {
    const { target: { value } } = event;
    setPersonName(typeof value === 'string' ? value.split(',') : value);
  };

  const capture = async () => {
    try {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: true,
        resultType: CameraResultType.Base64,
      });
      setBase64(image.base64String);
      setPerson(`data:image/jpeg;base64,${image.base64String}`);
    } catch (error) {
      console.error('Error capturing photo:', error);
    }
  };

  const clearForm = () => {
    setGender('none');
    setPosition('none');
    setIniPosition('none');
    setEmploymentType('none');
    setMarrital('none');
    setPersonName([]);
    setPerson('');
    setBase64('');
    document.getElementById('surname').value = '';
    document.getElementById('othername').value = '';
    document.getElementById('lastname').value = '';
    document.getElementById('contact').value = '';
    document.getElementById('idnumber').value = '';
    document.getElementById('ssnit').value = '';
    document.getElementById('dob').value = '';
    document.getElementById('license').value = '';
    document.getElementById('expiry').value = '';
    document.getElementById('dateemployed').value = '';
    document.getElementById('address').value = '';
    document.getElementById('others').value = '';
  };

  const addStaff = async () => {
    setLoading(true);
    const fd = new FormData();
    fd.append('base64Image', base64);
    fd.append('surname', document.getElementById('surname').value);
    fd.append('othername', document.getElementById('othername').value);
    fd.append('lastname', document.getElementById('lastname').value);
    fd.append('email', document.getElementById('email').value);
    fd.append('contact', document.getElementById('contact').value);
    fd.append('idnumber', document.getElementById('idnumber').value);
    fd.append('ssnit', document.getElementById('ssnit').value);
    fd.append('gender', gender);
    fd.append('dob', document.getElementById('dob').value);
    fd.append('license', document.getElementById('license').value);
    fd.append('expiry', document.getElementById('expiry').value);
    fd.append('dateemployed', document.getElementById('dateemployed').value);
    fd.append('iniposition', iniPosition);
    fd.append('position', position);
    fd.append('employmenttype', employmentType);
    fd.append('marrital', marrital);
    fd.append('assetusage', JSON.stringify(personName));
    fd.append('address', document.getElementById('address').value);
    fd.append('others', document.getElementById('others').value);
    fd.append('canLogin', canLogin);
    fd.append('part', 'staff');

    try {
      const res = await axios.post('https://embert.sisrevolution.com/api/staff/addstaff/', fd, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (res.status === 200) {
        setLoading(false);
        dispatch(getstaff({ data: res.data }));
        setSnackbarMessage('Staff added successfully!');
        setSnackbarOpen(true);
        clearForm();
        setTimeout(() => handleClose(), 1500); // Close dialog after 1.5s
      } else {
        setLoading(false);
        setSnackbarMessage('Failed to add staff.');
        setSnackbarOpen(true);
      }
    } catch (err) {
      setLoading(false);
      setSnackbarMessage('Error adding staff.');
      setSnackbarOpen(true);
    }
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<EngineeringIcon />} onClick={handleOpen}>
        Add Staff
      </Button>
      <Dialog fullWidth minWidth="sm" open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title">
          Add New Staff
          <IconButton onClick={handleClose} style={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="on"
          >
            <div style={{ width: '100%', textAlign: 'center', marginBottom: '20px' }}>
              <Box
                onClick={capture}
                sx={{
                  backgroundColor: 'white',
                  border: '1px solid grey',
                  width: '100px',
                  height: '100px',
                  margin: '0 auto',
                  borderRadius: '50%',
                  textAlign: 'center',
                  cursor: 'pointer',
                  position: 'relative',
                  overflow: 'hidden',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
              >
                {person ? (
                  <Avatar
                    src={person}
                    sx={{ width: '100%', height: '100%', borderRadius: '50%' }}
                  />
                ) : (
                  <Box sx={{ padding: '20px' }}>
                    <CameraAltIcon sx={{ fontSize: 40, color: 'grey' }} />
                  </Box>
                )}
              </Box>
            </div>
            
            <TextField id="surname" label="Surname" type="text" autoComplete="current-text" />
            <TextField id="othername" label="Other Names" type="text" autoComplete="current-text" />
            <TextField id="lastname" label="Last Names" type="text" autoComplete="current-text" />
            <TextField
              id="dob"
              label="Date Of Birth"
              type="date"
              autoComplete="current-text"
              InputLabelProps={{ shrink: true }}
            />
            <TextField id="idnumber" label="ID Number" type="text" autoComplete="current-text" />
            <TextField id="ssnit" label="SSNIT" type="text" autoComplete="current-text" />
            <TextField id="license" label="Driver's License Number" type="text" autoComplete="current-text" />
            <TextField
              id="expiry"
              label="License Expiry Date"
              type="date"
              autoComplete="current-text"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              id="outlined-select-currency-native"
              select
              label="Gender"
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Choose</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </TextField>
            <TextField
              id="dateemployed"
              label="Date Employed"
              type="date"
              autoComplete="current-text"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              id="outlined-select-currency-native"
              select
              label="Employment Type"
              value={employmentType}
              onChange={(e) => setEmploymentType(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Choose</option>
              <option value="Permanent">Permanent</option>
              <option value="Temporal">Temporal</option>
              <option value="Contract">Contract</option>
            </TextField>
            <TextField required id="contact" label="Contact" type="tel" autoComplete="current-text" />
            <TextField required id="email" label="Email" type="email" autoComplete="current-text" />

            <TextField id="address" label="Address" type="text" autoComplete="current-text" />
            <TextField
              id="outlined-select-currency-native"
              select
              label="Marital Status"
              value={marrital}
              onChange={(e) => setMarrital(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Choose</option>
              <option value="Single">Single</option>
              <option value="Married">Married</option>
              <option value="Divorced">Divorced</option>
              <option value="Complicated">Complicated</option>
            </TextField>
            <TextField
              id="outlined-select-currency-native"
              select
              label="Initial Position"
              value={iniPosition}
              onChange={(e) => setIniPosition(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Choose</option>
              <option value="Manager">Manager</option>
              <option value="Secretary">Secretary</option>
              <option value="Field Agent">Field Agent</option>
              <option value="Sourcing Agent">Sourcing Agent</option>
              <option value="Driver">Driver</option>
              <option value="Security">Security</option>
            </TextField>
            <TextField
              id="outlined-select-currency-native"
              select
              label="Current Position"
              value={position}
              onChange={(e) => setPosition(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Choose</option>
              <option value="Manager">Manager</option>
              <option value="Secretary">Secretary</option>
              <option value="Field Agent">Field Agent</option>
              <option value="Sourcing Agent">Sourcing Agent</option>
              <option value="Driver">Driver</option>
              <option value="Security">Security</option>
            </TextField>
            <FormControl sx={{ m: 1, width: 225 }}>
              <InputLabel id="demo-multiple-checkbox-label">Asset Usage</InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={personName}
                onChange={handleChange}
                input={<OutlinedInput label="Asset Usage" />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
              >
                {names.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={personName.includes(name)} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField id="others" label="Other Descriptions" multiline rows={4} />
            <FormControlLabel
              control={<Switch checked={canLogin} onChange={e => setCanLogin(e.target.checked)} color="primary" />}
              label="Grant Login Access"
              sx={{ m: 1 }}
            />
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <div style={{ marginTop: 2, textAlign: 'center', width: '100%' }}>
            {loading ? (
              <Button variant="outlined" startIcon={<Progress />} disabled>
                Loading...
              </Button>
            ) : (
              <Button variant="outlined" startIcon={<EngineeringIcon />} size="large" onClick={addStaff}>
                Submit New Staff
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarMessage.includes('success') ? 'success' : 'error'}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}